<template>
  <v-app id="inspire" class=" tw-bg-white">
    <r-f-q-nav v-if="isAuthenticated" />

    <div class="tw-w-full tw-flex tw-h-full lg:tw-h-full tw-items-center tw-px-2 lg:tw-px-4">
      <v-col class="tw-h-auto md:tw-h-auto" cols="12" sm="12" md="5">
        <div v-if="isAuthenticated">
          <div class="tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-mt-20 lg:tw-mt-0">
            <div class="tw-w-full tw-flex tw-items-center tw-justify-center">
              <img class="tw-w-24" src="/images/smiley.png"  alt="smiley">
              <div class="tw-px-2 md:tw-px-5 c-blue-text">
                <h1 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-medium">Welcome Back {{authenticatedUser.name.split(' ')[0] || authenticatedUser.name}}</h1>
                <p>Here is a quick menu to get things done</p>
              </div>
            </div>
            <div class="tw-flex tw-w-full md:tw-w-11/12 2xl:tw-w-9/12 tw-justify-center tw-mt-5 md:tw-mt-12 tw-grid tw-grid-cols-2 md:tw-grid-cols-2 tw-text-center">
              <router-link id="dashboard" :to="{ name: 'Dashboard' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4">
                <img width="70" class="tw-mb-3 tw-self-center" src="/images/landing/dashboard.png"  alt="dashboard">
                <div class="c-blue-text">Dashboard <v-icon color="primary">mdi-chevron-right</v-icon></div>
              </router-link>
              <router-link id="quotes" :to="{ name: 'SavedQuotes' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4">
                <img width="70" class="tw-mb-3 tw-self-center" src="/images/landing/resume.png"  alt="dashboard">
                <div class="c-blue-text">Resume Quote <v-icon color="primary">mdi-chevron-right</v-icon></div>
              </router-link>
              <router-link id="policies" :to="{ name: 'MyPolicies' }" class="tw-flex tw-flex-col tw-justify-center tw-mx-4 tw-mt-4 md:tw-mt-8">
                <img width="70" class="tw-mb-3 tw-self-center" src="/images/landing/policies.png"  alt="dashboard">
                <div class="c-blue-text">My Policies <v-icon color="primary">mdi-chevron-right</v-icon></div>
              </router-link>
              <a id="claim" href="https://www.apainsurance.org/claim_motor.php" target="_blank" rel="noopener noreferrer" class="tw-flex tw-flex-col tw-justify-center tw-mx-4 tw-mt-4 md:tw-mt-8">
                <img width="70" class="tw-mb-3 tw-self-center" src="/images/landing/claim.png"  alt="dashboard">
                <div class="c-blue-text">Report Claim <v-icon color="primary">mdi-chevron-right</v-icon></div>
              </a>
            </div>
          </div>
        </div>
        <div v-else class="tw-w-full tw-flex flex-wrap tw-justify-center tw-mt-10 lg:tw-mt-0">
          <div class="tw-w-full tw-flex tw-justify-center">
            <img class="tw-h-32 tw-w-auto tw-mb-10 lg:tw-mb-12" src="/logo.svg" alt="Workflow logo">
          </div>
          <div class="tw-w-10/12 xl:tw-w-10/12 tw-text-center tw-flex flex-wrap tw-justify-center">
            <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-text-left">
              <img class="tw-w-24" src="/images/smiley.png"  alt="smiley">
              <div class="tw-px-2 md:tw-px-5">
                <h1 class="c-gray-text tw-text-xl md:tw-text-xl lg:tw-text-2xl tw-font-medium">Happiness at the click of a button.</h1>
                <p class="tw-font-bold c-blue-text">Buy, Renew, Claim and be happy wherever you go.</p>
              </div>
            </div>
            <div class="tw-w-full md:tw-w-10/12 tw-mt-6">
              <v-btn id="request-for-quote" :to="{name: 'SignUp'}" block large color="secondary" class="my-3 white--text tw-w-full animate-bounce">Request for Quotation</v-btn>

              <div class="tw-w-full tw-flex tw-my-5 lg:tw-my-8 tw-items-center c-gray-text">
                <div class="tw-w-5/12">
                  <hr>
                </div>
                <div class="tw-w-2/12">
                  OR
                </div>
                <div class="tw-w-5/12">
                  <hr>
                </div>
              </div>

              <div class="tw-w-full tw-flex tw-grid tw-grid-cols-2 tw-gap-2">
                <v-btn outlined color="primary" :to="{name: 'SignIn'}">
                  Login
                </v-btn>
                <v-btn color="primary" :to="{name: 'SignUp'}">
                  Register
                </v-btn>
              </div>

              <div v-if="isFlagEnabled('CUSTOMER_PORTAL_ENABLE_CLAIMS_LINK')" class="tw-w-full tw-flex tw-mt-12 tw-items-center c-gray-text">
                <div class="tw-flex-grow">
                  <hr>
                </div>
                <a id="submit-claim-link" :href="submitClaimUrl" target="_blank" rel="noopener noreferrer" class="tw-flex tw-items-center tw-gap-1 tw-px-3 c-blue-text tw-font-semibold tw-text-sm hover:tw-underline tw-whitespace-nowrap">
                  <span>Submit a Claim</span>
                  <v-icon color="primary" x-small>mdi-arrow-top-right</v-icon>
                </a>
                <div class="tw-flex-grow">
                  <hr>
                </div>
              </div>

              <div v-if="show" class="tw-w-full tw-mt-4 md:tw-mt-10 tw-text-left c-blue-text tw-flex tw-items-center">
                <a id="playstore-link" class="" href="https://play.google.com/store/apps/details?id=ke.co.apollo.client.app" target="_blank" rel="noopener"><img src="/images/google-play-badge.png" alt="play store"></a>
                <p class="tw-text-xs md:tw-text-sm md:tw-text-left tw-px-2  tw-mt-3">You can also download our Motor Happiness App on the Google play store</p>
              </div>
            </div>
          </div>
        </div>
        <div class="tw-w-full lg:tw-w-5/12 tw-grid tw-grid-cols-2 tw-absolute tw-left-0 tw-bottom-0">
          <div class="c-bg-blue tw-py-1"></div>
          <div class="c-bg-red tw-py-1"></div>
        </div>
      </v-col>
      <v-col class="tw-hidden lg:tw-block image tw-h-auto lg:tw-h-screen tw-relative lg:tw-absolute tw-right-auto lg:tw-right-0" cols="12" sm="12" md="7">
      </v-col>
    </div>

  </v-app>
</template>

<script>
import RFQNav from '@/components/layout/partials/RFQNav';
import { mapGetters } from 'vuex';
import unleashMixin from '@/mixins/unleashMixin';

export default {
  name: 'Landing',
  mixins: [unleashMixin],
  components: { RFQNav },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
    submitClaimUrl() {
      return process.env.VUE_APP_SUBMIT_CLAIM_URL;
    },
  },
  metaInfo: {
    title: 'Home',
  },
};
</script>

<style lang="scss" scoped>

.animate-bounce {
  animation: bounce 1s infinite
}

.image {
  background-image: url('/images/bima.jpg');
  background-repeat: no-repeat;
  background-position: left;
  background-size: contain;
  background-color: #D8EBFA;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
</style>
